import jsPDF from 'jspdf';
import * as htmlToImage from 'html-to-image';

function formatDate(date: Date) {
  let currentDate = new Date(date);
  let month = (currentDate.getMonth() + 1).toString();
  if (parseInt(month) < 10) month = '0' + month;
  let dateOfMonth = currentDate.getDate().toString();
  if (parseInt(dateOfMonth) < 10) dateOfMonth = '0' + dateOfMonth;
  let year = currentDate.getFullYear();
  let formattedDate = dateOfMonth + '/' + month + '/' + year;
  return formattedDate;
}

function hideDescriptionElements() {
  const elements: any = document.getElementsByClassName('graph-description');
  for (let i = 0; i < elements.length; i++) {
    elements[i].style.display = 'none';
  }
}

function showSpecies() {
  var cols = document.getElementsByClassName(
    'legend-table-hidden-row',
  ) as HTMLCollectionOf<HTMLElement>;
  const row: HTMLElement = document.getElementById('Other') as HTMLElement;
  const arrow: HTMLElement = document.getElementById(
    'table-arrow',
  ) as HTMLElement;
  if (row) {
    row.style.borderBottom = '1px solid rgba(191, 185, 199, 0.4)';
  }
  if (arrow) {
    arrow.classList.remove('down');
    arrow.classList.add('up');
  }
  for (let i = 0; i < cols.length; i++) {
    cols[i].style.display = '';
    cols[i].classList.remove('highlight-row');
  }
}

function hideSpecies() {
  var cols = document.getElementsByClassName(
    'legend-table-hidden-row',
  ) as HTMLCollectionOf<HTMLElement>;
  const row: HTMLElement = document.getElementById('Other') as HTMLElement;
  const arrow: HTMLElement = document.getElementById(
    'table-arrow',
  ) as HTMLElement;
  if (row) {
    row.style.borderBottom = '';
  }
  if (arrow) {
    arrow.classList.remove('up');
    arrow.classList.add('down');
  }
  for (let i = 0; i < cols.length; i++) {
    cols[i].style.display = 'none';
    cols[i].classList.add('highlight-row');
  }
}

function showDescriptionElements() {
  const elements: any = document.getElementsByClassName('graph-description');
  for (let i = 0; i < elements.length; i++) {
    elements[i].style.display = '';
  }
}

export async function exportMultipleChartsToPdf(
  site: string,
  startDate: Date,
  endDate: Date,
) {
  const doc = new jsPDF('p', 'px');
  // const site = 'Ustira';
  const formattedStartDate = formatDate(startDate);
  const formattedEndDate = formatDate(endDate);
  const elements = document.getElementsByClassName('custom-chart');
  // eslint-disable-next-line no-template-curly-in-string
  let titleElement: any =
    '<div style="margin-left: 150px; width: 200px; font-size:14px;font-family:helvetica; color: black">' +
    `Report for ${site}` +
    '</div>' +
    '<div style="margin-left: 10px;width: 400px; font-size:14px;font-family:helvetica; color: grey">' +
    `<span style="font-size: 8px;">Period: ${formattedStartDate} to ${formattedEndDate}</span>` +
    '</div>';
  doc.html(titleElement);

  hideDescriptionElements();
  showSpecies();
  await creatPdf({ doc, elements });
  showDescriptionElements();
  hideSpecies();
  doc.save(`report.pdf`);
}

async function creatPdf({
  doc,
  elements,
}: {
  doc: jsPDF;
  elements: HTMLCollectionOf<Element>;
}) {
  const padding = 10;
  const marginTop = 20;
  let top = marginTop;
  for (let i = 0; i < elements.length; i++) {
    const el = elements.item(i) as HTMLElement;
    const imgData = await htmlToImage.toPng(el);

    let elHeight = el.offsetHeight;
    let elWidth = el.offsetWidth;

    const pageWidth = doc.internal.pageSize.getWidth();

    if (elWidth > pageWidth + 200) {
      const ratio = pageWidth / elWidth;
      elHeight = elHeight * ratio - padding * 2;
      elWidth = elWidth * ratio - padding * 2;
    }

    const pageHeight = doc.internal.pageSize.getHeight();
    if (top + elHeight > pageHeight) {
      doc.addPage();
      top = marginTop;
    }
    if (i === 0) {
      top = 60;
    }
    doc.addImage(
      imgData,
      'PNG',
      padding,
      top,
      elWidth,
      elHeight,
      `image${i}`,
      'FAST',
    );

    top += elHeight + marginTop;
  }
}
